var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-panel",
    { attrs: { "header-text": _vm.listStructure.caption } },
    [
      _c("div", { staticClass: "q-toolbar" }, [
        _c(
          "div",
          { staticClass: "q-toolbar-buttons" },
          [
            _c(
              "q-button",
              {
                staticClass: "q-toolbar-btn",
                style: _vm.firstButtonStyle,
                on: { click: _vm.newModel },
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "plus"] } })],
              1
            ),
            _vm._v(" "),
            _c(
              "q-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasSelection,
                    expression: "hasSelection",
                  },
                ],
                staticClass: "q-toolbar-btn",
                on: {
                  click: function ($event) {
                    _vm.deleteDialog = true
                  },
                },
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "trash"] } })],
              1
            ),
            _vm._v(" "),
            _c(
              "q-button",
              {
                staticClass: "q-toolbar-btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.limitationDialog = true
                  },
                },
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "filter"] } })],
              1
            ),
            _vm._v(" "),
            _c(
              "q-button",
              { staticClass: "q-toolbar-btn", on: { click: _vm.refreshRows } },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fas", "sync-alt"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("q-divider", { attrs: { direction: "vertical" } }),
            _vm._v(" "),
            _c(
              "q-button",
              {
                staticClass: "q-toolbar-btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.structureDialog = true
                  },
                },
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "cog"] } })],
              1
            ),
            _vm._v(" "),
            _c("q-divider", { attrs: { direction: "vertical" } }),
            _vm._v(" "),
            _c("a", {
              staticStyle: { display: "none" },
              attrs: { id: "downloadAnchorElem" },
            }),
            _vm._v(" "),
            _c(
              "q-button",
              {
                staticClass: "q-toolbar-btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.exportDialog = true
                  },
                },
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "upload"] } })],
              1
            ),
            _vm._v(" "),
            _c(
              "q-button",
              {
                staticClass: "q-toolbar-btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.importDialog = true
                  },
                },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fas", "download"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("q-divider", { attrs: { direction: "vertical" } }),
            _vm._v(" "),
            _c(
              "q-dropdown",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasSelection,
                    expression: "hasSelection",
                  },
                ],
                staticClass: "q-toolbar-btn",
                attrs: { trigger: "click" },
                on: { command: _vm.runMethods },
              },
              [
                _c("q-button", [
                  _c("span", [
                    _vm._v(_vm._s(this.$qt("listStructure.actionCaption"))),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "q-icon-arrow-down q-icon--right" }),
                ]),
                _vm._v(" "),
                _c(
                  "q-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  _vm._l(_vm.listStructure.methods, function (method) {
                    return _c(
                      "q-dropdown-item",
                      { key: method.key, attrs: { command: method } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(method.caption) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-dropdown",
              {
                staticClass: "q-toolbar-btn",
                attrs: { trigger: "click" },
                on: { command: _vm.createReport },
              },
              [
                _c(
                  "q-button",
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "chart-bar"] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "q-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  _vm._l(_vm.listStructure.reports, function (report) {
                    return _c(
                      "q-dropdown-item",
                      { key: report.key, attrs: { command: report } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(report.caption) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-input",
              {
                style: _vm.searchStyle,
                attrs: {
                  placeholder: this.$qt("listStructure.searchPlaceHolder"),
                },
                model: {
                  value: _vm.word,
                  callback: function ($$v) {
                    _vm.word = $$v
                  },
                  expression: "word",
                },
              },
              [
                _c("q-button", {
                  attrs: {
                    slot: "append",
                    type: "info",
                    icon: "q-icon-search",
                  },
                  slot: "append",
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "q-table",
        {
          attrs: {
            stripe: "",
            data: _vm.filteredData,
            width: _vm.listStructure.width,
            "sum-text": "----",
            "empty-text": this.$qt("listStructure.emptyList"),
          },
          on: {
            "row-click": _vm.rowSelected,
            "selection-change": _vm.handleSelectionChange,
          },
        },
        [
          _c("q-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("q-table-column", {
            attrs: { label: "", width: "40" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "detail",
                            params: {
                              structureKey: _vm.listStructure.detailFormKey,
                              modelId: scope.row["id"],
                            },
                          },
                        },
                      },
                      [_c("font-awesome-icon", { attrs: { icon: "edit" } })],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm._l(_vm.listStructure.columns, function (col) {
            return _c("q-table-column", {
              key: col.key,
              attrs: {
                type: col.type,
                sortable: col.sortable === true,
                label: col.caption,
                width: col.width === 0 ? undefined : col.width,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        col.fieldType === "DatePicker"
                          ? [
                              _c(
                                "span",
                                { staticStyle: { direction: "ltr" } },
                                [_vm._v(_vm._s(scope.row[col.key]))]
                              ),
                            ]
                          : col.fieldType === "CheckBox"
                          ? [
                              scope.row[col.key] === true
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "check" },
                                  })
                                : _c("font-awesome-icon", {
                                    attrs: { icon: "times" },
                                  }),
                            ]
                          : col.fieldType === "model"
                          ? [_c("span", [_vm._v("AMIN")])]
                          : [_c("span", [_vm._v(_vm._s(scope.row[col.key]))])],
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("q-pagination", {
        attrs: {
          "page-size": _vm.listStructure.itemInPage,
          "pager-count": 13,
          total: _vm.modelsQty,
          layout: "prev ,pager , next",
          "current-page": _vm.currentPage,
          "next-text": this.$qt("listStructure.pagination.nextText"),
          "prev-text": this.$qt("listStructure.pagination.prevText"),
          background: "",
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
          "current-change": _vm.changePage,
        },
      }),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("listStructure.settingTitle"),
            width: "50%",
            visible: _vm.structureDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.structureDialog = $event
            },
          },
        },
        [
          _c("list-structure-detail", {
            on: {
              close: function ($event) {
                _vm.structureDialog = false
              },
            },
            model: {
              value: _vm.listStructure,
              callback: function ($$v) {
                _vm.listStructure = $$v
              },
              expression: "listStructure",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("listStructure.limitationTitle"),
            width: "50%",
            visible: _vm.limitationDialog,
            "close-on-press-escape": false,
            "close-on-click-modal:": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.limitationDialog = $event
            },
          },
        },
        [
          _vm.limitationStructure
            ? _c(
                "div",
                [
                  _c(
                    "q-form",
                    {
                      ref: "limitationForm",
                      attrs: {
                        model: _vm.rangeModel,
                        rules: _vm.rangeRules,
                        "labq-width": "150px",
                      },
                    },
                    [
                      _c("q-form-generator", {
                        attrs: { "form-structure": _vm.limitationStructure },
                        model: {
                          value: _vm.rangeModel,
                          callback: function ($$v) {
                            _vm.rangeModel = $$v
                          },
                          expression: "rangeModel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("div", [
                _c("span", [
                  _vm._v(_vm._s(this.$qt("listStructure.limitationNotSet"))),
                ]),
              ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                { attrs: { type: "primary" }, on: { click: _vm.limit } },
                [_vm._v(_vm._s(this.$qt("listStructure.confirmLimitation")))]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.limitationDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(this.$qt("listStructure.rejectLimitation")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("model.deleteDialog.title"),
            visible: _vm.deleteDialog,
            width: "30%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteDialog = $event
            },
          },
        },
        [
          _c("span", [
            _vm._v(_vm._s(this.$qt("model.deleteDialog.warningNote"))),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteModel()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("model.deleteDialog.confirm")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deleteDialog = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("model.deleteDialog.cancel")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("listStructure.importDialogTitle"),
            width: "50%",
            visible: _vm.importDialog,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("h3", [_vm._v("IMPORT DIALOG m")]),
              _vm._v(" "),
              _c(
                "q-form",
                {
                  ref: "importForm",
                  attrs: {
                    model: _vm.importModel,
                    rules: _vm.importModelRules,
                    "labq-width": "150px",
                  },
                },
                [
                  _c(
                    "q-form-item",
                    {
                      attrs: {
                        label: this.$qt("listStructure.selectFileForImport"),
                        prop: "modelsFile",
                      },
                    },
                    [
                      _c("q-upload", {
                        attrs: { type: "json" },
                        model: {
                          value: _vm.importModel.models,
                          callback: function ($$v) {
                            _vm.$set(_vm.importModel, "models", $$v)
                          },
                          expression: "importModel.models",
                        },
                      }),
                      _vm._v(" "),
                      _c("q-json", [_vm._v(_vm._s(_vm.importModel))]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.importModels()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("listStructure.importButton")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.importDialog = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("listStructure.rejectLimitation")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("listStructure.exportDialogTitle"),
            width: "50%",
            visible: _vm.exportDialog,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.exportDialog = $event
            },
          },
        },
        [
          _c(
            "q-form",
            {
              ref: "limitationForm",
              attrs: { model: _vm.exportSetting, "labq-width": "150px" },
            },
            [
              _c(
                "q-form-item",
                { attrs: { prop: "removeId" } },
                [
                  _c(
                    "q-checkbox",
                    {
                      model: {
                        value: _vm.exportSetting.removeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.exportSetting, "removeId", $$v)
                        },
                        expression: "exportSetting.removeId",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            this.$qt(
                              "listStructure.exportSetting.removeIdTitle"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.exportModels()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("listStructure.exportButton")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.exportDialog = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("listStructure.rejectLimitation")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }